import React from 'react';
import { History } from 'history';
import Model from './user-model';  //editable..
import PersonalinfoEdit from '../personalinfo/personalinfo-edit.component';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    dataRow: Model;
}

export default class UserAuthProfile extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            dataRow: Model.defaultValue()
        }
    }

    render() {
        return (
            <PersonalinfoEdit history={this.props.history} root={this.props.root} caption='User Profile' userId={+Model.getUser()} />
        )
    }
}